module.exports = __webpack_public_path__ + "static/media/ico_add_prd.01ed0aee.svg";